import { createSlice } from '@reduxjs/toolkit'
import { act } from 'react'

const initialState = {
    producerDetails:{}
}
export const ProducerApprovalRejectionSlice = createSlice({
    name: 'producerRegistrationApprovalRejection',
    initialState,
    reducers: {
        setProducerDetails:(state,action)=>{
            state.producerDetails=action.payload.producerDetails;
        }
    }
})

export const {setProducerDetails } = ProducerApprovalRejectionSlice.actions

export default ProducerApprovalRejectionSlice.reducer